import { render, staticRenderFns } from "./PageNotification.vue?vue&type=template&id=0915dfae&scoped=true&"
import script from "./PageNotification.vue?vue&type=script&lang=js&"
export * from "./PageNotification.vue?vue&type=script&lang=js&"
import style0 from "./PageNotification.vue?vue&type=style&index=0&id=0915dfae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915dfae",
  null
  
)

export default component.exports